import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import PhotoGallery from "@/components/PhotoGallery";

export default function ClientPhotos() {
  const { user } = useAuth();
  const [photos, setPhotos] = useState([]);

  useEffect(() => {
    if (!user) return;
    api.get(`/clients/${user.user_id}/photos`).then(({ data }) => setPhotos(data));
  }, [user]);

  return (
    <div data-testid="client-photos">
      <div className="label-tiny">Galleria</div>
      <h1 className="font-serif text-5xl tracking-tight mt-2">Foto rilievi</h1>
      <p className="mt-3 text-sm text-[color:var(--text-secondary)] max-w-lg">
        La documentazione visiva del tuo percorso. Usa <strong>Confronta</strong> per vedere due scatti dello stesso angolo affiancati.
      </p>

      <div className="mt-10">
        <PhotoGallery photos={photos} />
      </div>
    </div>
  );
}
